import { render, staticRenderFns } from "./ProjectPage.vue?vue&type=template&id=0027408c&"
import script from "./ProjectPage.vue?vue&type=script&lang=js&"
export * from "./ProjectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports